import React, { Component } from 'react'
import {
    Card, CardImg, Row, CardBody, Col, CardText,
    CardTitle, CardSubtitle, Button, CardFooter
} from 'reactstrap'
import './ItemProducto.css'
import ModalProductos from '../modal'
import ReactPixel from 'react-facebook-pixel'

class ItemProducto extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            porcentajePuntos: 2
        }
        this.toggle = this.toggle.bind(this)
        this.editarProducto = this.editarProducto.bind(this)
        this.eliminarProducto = this.eliminarProducto.bind(this)
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        })
        ReactPixel.fbq('track', 'Search')
    }

    createModalBody() {
        return (
            <Row>
                <Col>
                    <CardImg src={this.props.producto.Img} />

                </Col>
                <Col>
                    {this.props.producto.Detalle}
                    <div className="precioModal">
                        <strong>Precio: ${this.props.producto.Precio}</strong>
                        <div className="puntajeProducto">
                            {this.calcularPrecioPuntos(this.props.producto.Precio, this.props.producto.PrecioPuntos)}
                        </div>
                        <div className="puntajeProducto">
                            {this.calcularPuntos(this.props.producto.Precio)}
                        </div>
                    </div>
                </Col>
            </Row>
        )
    }

    editarProducto() {
        const prod = {
            ...this.props.producto,
            id: this.props.id
        }
        this.props.productoEditar(prod)
    }

    eliminarProducto() {
        const prod = {
            ...this.props.producto,
            id: this.props.id
        }
        this.props.productoEliminar(prod)
    }

    btnInfo() {
        if (!this.props.btnInfoDisabled) {
            return (
                <Button onClick={this.toggle} className="btn-block btn-sm" block color="warning">Info</Button>
            )
        }
        return (
            <Row>
                <Col>
                    <Button color="warning" onClick={this.editarProducto} block>Editar</Button>
                </Col>
                <Col>
                    <Button color="danger" onClick={this.eliminarProducto} block>Eliminar</Button>
                </Col>
            </Row>
        )
    }

    agotado() {
        if (this.props.producto.Agotado) {
            return (
                <div className="Agotado"> Agotado </div>
            )
        }
    }

    calcularPrecioPuntos(precio, precioPuntos) {
        if (precioPuntos === undefined) {
            return ''
        }
        const dif = parseFloat(precio) - parseFloat(precioPuntos)
        return ` ${parseInt(dif * this.state.porcentajePuntos)} puntos + $${precioPuntos}`
    }

    calcularPuntos(precio) {
        return `${parseInt(precio * this.state.porcentajePuntos)} puntos`
    }

    render() {
        return (
            <div>
                <Card className="ItemProducto">
                    <div className="ItemProductoImg">
                        <CardImg className="text-center" src={this.props.producto.Img} alt={this.props.producto.Descripcion} />
                    </div>
                    <div>
                        {this.agotado()}
                    </div>
                    <CardBody className="itemProductoDetalles">
                        <CardTitle>
                            <p className="ItemProductoTitulo">{this.props.producto.Descripcion}</p>
                        </CardTitle>
                        <CardSubtitle>
                            <strong>
                                Precio: ${this.props.producto.Precio}
                            </strong>
                            <div className="puntajeProducto">
                                {this.calcularPrecioPuntos(this.props.producto.Precio, this.props.producto.PrecioPuntos)}
                            </div>
                            <div className="puntajeProducto">
                                {this.calcularPuntos(this.props.producto.Precio)}
                            </div>
                        </CardSubtitle>
                        {/* <CardText>{props.Detalle}</CardText> */}

                    </CardBody>
                    <div className="cardFooter">
                        {
                            this.btnInfo()
                        }
                        <ModalProductos
                            toggle={this.toggle}
                            isOpen={this.state.modal}
                            modalTitle={this.props.producto.Descripcion}
                            modalBody={this.createModalBody()}
                        >
                        </ModalProductos>
                    </div>
                </Card>
            </div>
        )
    }

}

export default ItemProducto;